import { secureLogout } from '../api/config';

// Helper function to determine correct login route based on user type
const getLoginRoute = () => {
  const user = localStorage.getItem('user');
  
  // If user exists in localStorage, they're an admin user
  if (user) {
    return '/admin/login';
  }
  // If customer exists or neither exists, use customer login
  return '/login';
};

// Secure logout utility
export const logout = async () => {
  try {
    await secureLogout();
  } catch (error) {
    console.error('Logout error:', error);
    // Clear local storage even if API call fails
    const loginRoute = getLoginRoute();
    localStorage.removeItem('user');
    localStorage.removeItem('customer');
    localStorage.removeItem('defaultStation');
    localStorage.removeItem('token');
    window.location.href = loginRoute;
  }
};

// Check if user is authenticated based on stored data
export const isAuthenticated = () => {
  const user = localStorage.getItem('user');
  const customer = localStorage.getItem('customer');
  return !!(user || customer);
};

// Get current user data
export const getCurrentUser = () => {
  try {
    const user = localStorage.getItem('user');
    const customer = localStorage.getItem('customer');
    
    if (user) {
      return { type: 'user', data: JSON.parse(user) };
    }
    if (customer) {
      return { type: 'customer', data: JSON.parse(customer) };
    }
    return null;
  } catch (error) {
    console.error('Error getting current user:', error);
    return null;
  }
};

// Clear all authentication data
export const clearAuthData = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('customer');
  localStorage.removeItem('defaultStation');
  localStorage.removeItem('token'); // Clear deprecated token
};

// Secure session check (for components)
export const checkSession = async () => {
  const currentUser = getCurrentUser();
  
  if (!currentUser) {
    // No local user data, redirect to appropriate login
    const loginRoute = getLoginRoute();
    window.location.href = loginRoute;
    return false;
  }
  
  // User data exists, assume session is valid
  // (Server will validate actual authentication via httpOnly cookies)
  return true;
};